import { InsuranceLoan, Rider } from "./";

export interface Insurance {
    id: number;
    user_id: number;
    contact_id: number;
    face_value: number;
    premium: number;
    cash_value: number | null;
    paid_to_date: Date | null;
    riders_collection: Rider[];
    insurance_loans_collection: InsuranceLoan[];
}

export const InitInsurance: Insurance = {
    id: 0,
    user_id: 0,
    contact_id: 0,
    face_value: 0,
    premium: 0,
    cash_value: null,
    paid_to_date: null,
    riders_collection: [],
    insurance_loans_collection: []
}
